import { createFileRoute } from "@tanstack/react-router"
import ScheduleIntakePage from "@/pages/home/intake/schedule"

export const Route = createFileRoute("/intake/inplannen")({
  component: ScheduleIntakePage,
})
